'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _partPositionTransformer = require('../transformers/composite/partPositionTransformer');

var _partPositionTransformer2 = _interopRequireDefault(_partPositionTransformer);

var _transformPartsWith = require('../transformers/composite/transformPartsWith');

var _transformPartsWith2 = _interopRequireDefault(_transformPartsWith);

var _expanders = require('../utils/expanders');

var _formatting = require('../utils/formatting');

var _axesExpander = require('./expanders/axesExpander');

var _axesExpander2 = _interopRequireDefault(_axesExpander);

var _cornerExpander = require('./expanders/cornerExpander');

var _cornerExpander2 = _interopRequireDefault(_cornerExpander);

var _directionExpander = require('./expanders/directionExpander');

var _directionExpander2 = _interopRequireDefault(_directionExpander);

var _directionsExpander = require('./expanders/directionsExpander');

var _directionsExpander2 = _interopRequireDefault(_directionsExpander);

var _minMaxExpander = require('./expanders/minMaxExpander');

var _minMaxExpander2 = _interopRequireDefault(_minMaxExpander);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Expanders take an item described in the config and expand it to multiple
// separate properties. For example 'padding' is expanded to 'padding-top',
// 'padding-right', 'padding-bottom' and 'padding-left', or 'directions' is
// expanded to 'top', 'right', 'bottom' and 'left'.
var EXPANDER_MAP = Object.freeze({
  padding: (0, _directionExpander2.default)(),
  margin: (0, _directionExpander2.default)(),
  border: (0, _directionExpander2.default)({
    mainWrapper: _transformPartsWith2.default,
    subWrapper: _transformPartsWith2.default
  }),
  borderWidth: (0, _directionExpander2.default)({
    createPropNameStrategy: _formatting.insertSubIntoProp
  }),
  borderStyle: (0, _directionExpander2.default)({
    createPropNameStrategy: _formatting.insertSubIntoProp
  }),
  borderColor: (0, _directionExpander2.default)({
    createPropNameStrategy: _formatting.insertSubIntoProp
  }),
  borderRadius: (0, _cornerExpander2.default)({
    createPropNameStrategy: _formatting.insertSubIntoProp
  }),
  width: (0, _minMaxExpander2.default)(),
  height: (0, _minMaxExpander2.default)(),
  directions: (0, _directionsExpander2.default)(),
  overflow: (0, _axesExpander2.default)(),
  outlineColor: (0, _expanders.wrapWithTransform)(_transformPartsWith2.default),
  outline: (0, _expanders.wrapWithTransform)(_transformPartsWith2.default),
  flex: (0, _expanders.wrapWithTransform)((0, _partPositionTransformer2.default)(2)),
  background: (0, _expanders.wrapWithTransform)(_transformPartsWith2.default),
  backgroundImage: (0, _expanders.wrapWithTransform)(_transformPartsWith2.default),
  backgroundPosition: (0, _axesExpander2.default)({
    mainWrapper: _transformPartsWith2.default,
    subWrapper: _transformPartsWith2.default
  }),
  boxShadow: (0, _expanders.wrapWithTransform)(_transformPartsWith2.default),
  transformOrigin: (0, _expanders.wrapWithTransform)(_transformPartsWith2.default),
  offset: (0, _expanders.wrapWithTransform)(_transformPartsWith2.default),
  offsetV: (0, _expanders.wrapWithTransform)(_transformPartsWith2.default),
  offsetH: (0, _expanders.wrapWithTransform)(_transformPartsWith2.default),
  paddingH: (0, _expanders.wrapWithTransform)(_transformPartsWith2.default),
  paddingV: (0, _expanders.wrapWithTransform)(_transformPartsWith2.default),
  marginH: (0, _expanders.wrapWithTransform)(_transformPartsWith2.default),
  marginV: (0, _expanders.wrapWithTransform)(_transformPartsWith2.default),
  borderH: (0, _expanders.wrapWithTransform)(_transformPartsWith2.default),
  borderV: (0, _expanders.wrapWithTransform)(_transformPartsWith2.default)
});

exports.default = EXPANDER_MAP;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/build/expanderMap.js
// module id = 645
// module chunks = 168707334958949